import React, { useEffect, useRef } from 'react';

const FertilizationCanvas = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    
    // Set canvas to full width and height of its container
    const resizeCanvas = () => {
      canvas.width = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;
    };

    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);

    // Initialize animation variables
    const spermCount = 13; // Number of sperm cells
    const spermArray = [];
    // const egg = { 
    //   x: canvas.width * 0.85, 
    //   y: canvas.height * 0.5, 
    //   radius: canvas.width * 0.04, 
    //   vibration: 0 
    // };
    const egg = { 
      x: canvas.width * 0.85, 
      y: canvas.height * 0.2, 
      radius: canvas.width * 0.01, 
      vibration: 0 
    };

    // Function to create a sperm cell
function createSperm() {
    return {
        x: Math.random() * canvas.width * 0.2, // Start from left side of the canvas (20% of the width)
        y: Math.random() * canvas.height, // Random vertical position within the canvas height
        speed: Math.random() * 10 + 1, // Speed of the sperm cell towards the egg (range: 1 to 11)
        wiggle: Math.random() * 0.1 + 0.05, // Random intensity of the wiggle effect (range: 0.05 to 0.15)
        wiggleSpeed: Math.random() * 0.02 + 0.002, // Speed of the wiggle motion (range: 0.02 to 0.04)
        wiggleOffset: Math.random() * Math.PI * 2, // Random offset for the wiggle effect to create variation
        size: Math.random() * 2 + 3, // Random size of the sperm cell (range: 3 to 5)
        color: [
            'rgba(15, 118, 110, 0.1)', // Color option 1 (light opacity)
            'rgba(30, 64, 175, 0.5)',  // Color option 2 (medium opacity)
            'rgba(67, 56, 202, 0.3)'   // Color option 3 (medium opacity)
        ][Math.floor(Math.random() * 3)], // Randomly select one of the color options
        tailLength: Math.random() * 10 + 15 // Random length of the tail (range: 15 to 25)
    };
}

    // Initialize sperm cells
    for (let i = 0; i < spermCount; i++) {
      spermArray.push(createSperm());
    }


// Function to draw sperm cells
function drawSperm(sperm) {
    const headSize = sperm.size; // Get the size of the sperm head from the sperm object
    const tailLength = sperm.tailLength; // Get the length of the sperm tail from the sperm object
    const tailSegments = 8; // Define the number of segments for the tail

    // Draw the head of the sperm (slightly oval shape)
    ctx.fillStyle = sperm.color; // Set the fill color to the sperm's color
    ctx.beginPath(); // Begin a new path for drawing
    ctx.ellipse(sperm.x, sperm.y, headSize * 1.2, headSize, 0, 0, Math.PI * 2); // Draw an oval for the head
    ctx.fill(); // Fill the head with the specified color
    
    // Add a highlight to the head for a shiny effect
    ctx.fillStyle = 'rgba(255, 255, 255, 0.7)'; // Set the fill color to a semi-transparent white
    ctx.beginPath(); // Begin a new path for the highlight
    ctx.arc(sperm.x - headSize / 3, sperm.y - headSize / 3, headSize / 3, 0, Math.PI * 2); // Draw a circle for the highlight
    ctx.fill(); // Fill the highlight with the specified color

    // Calculate the angle to the egg
    const angleToEgg = Math.atan2(egg.y - sperm.y, egg.x - sperm.x);

    // Draw the tail with a squiggly motion
    ctx.beginPath(); // Begin a new path for the tail
    ctx.moveTo(sperm.x - headSize, sperm.y); // Move to the starting point of the tail (just behind the head)
    
    // Loop through each segment of the tail to create a squiggly effect
    for (let i = 1; i <= tailSegments; i++) {
        const segment = i / tailSegments; // Calculate the current segment's position
        const tailX = sperm.x - (tailLength * segment) * Math.cos(angleToEgg); // Calculate the x position for the tail segment
        const tailY = sperm.y - (tailLength * segment) * Math.sin(angleToEgg); // Calculate the y position for the tail segment
        
        // Calculate the wiggle amount using a sine function for a squiggly effect
        const wiggleAmount = Math.sin((Date.now() * 5.01 * sperm.wiggleSpeed) + sperm.wiggleOffset + (segment * 10)) * 
                              (sperm.wiggle * 30) * segment; // Adjust wiggle intensity and size
        
        ctx.lineTo(tailX, tailY + wiggleAmount * 2); // Draw a line to the calculated tail segment position
    }
    
    // Set the stroke style for the tail
    ctx.strokeStyle = sperm.color; // Set the stroke color to the sperm's color
    ctx.lineWidth = headSize * 0.7; // Set the line width based on the head size
    ctx.lineCap = 'round'; // Set the line cap style to round for smoother edges
    ctx.stroke(); // Render the tail by stroking the path
}    
    // Function to draw sperm cells
//     function drawSperm(sperm) {
//     const headSize = sperm.size; // Get the size of the sperm head from the sperm object
//     const tailLength = sperm.tailLength; // Get the length of the sperm tail from the sperm object
//     const tailSegments = 8; // Define the number of segments for the tail

//     // Draw the head of the sperm (slightly oval shape)
//     ctx.fillStyle = sperm.color; // Set the fill color to the sperm's color
//     ctx.beginPath(); // Begin a new path for drawing
//     ctx.ellipse(sperm.x, sperm.y, headSize * 1.2, headSize, 0, 0, Math.PI * 2); // Draw an oval for the head
//     ctx.fill(); // Fill the head with the specified color
    
//     // Add a highlight to the head for a shiny effect
//     ctx.fillStyle = 'rgba(255, 255, 255, 0.7)'; // Set the fill color to a semi-transparent white
//     ctx.beginPath(); // Begin a new path for the highlight
//     ctx.arc(sperm.x - headSize / 3, sperm.y - headSize / 3, headSize / 3, 0, Math.PI * 2); // Draw a circle for the highlight
//     ctx.fill(); // Fill the highlight with the specified color

//     // Draw the tail with a squiggly motion
//     ctx.beginPath(); // Begin a new path for the tail
//     ctx.moveTo(sperm.x - headSize, sperm.y); // Move to the starting point of the tail (just behind the head)
    
//     // Loop through each segment of the tail to create a squiggly effect
//     for (let i = 1; i <= tailSegments; i++) {
//         const segment = i / tailSegments; // Calculate the current segment's position
//         const tailX = sperm.x - (tailLength * segment); // Calculate the x position for the tail segment
//         // Calculate the wiggle amount using a sine function for a squiggly effect
//         const wiggleAmount = Math.sin((Date.now() * 5.01 * sperm.wiggleSpeed) + sperm.wiggleOffset + (segment * 10)) * 
//                               (sperm.wiggle * 30) * segment; // Adjust wiggle intensity and size
//         const tailY = sperm.y + wiggleAmount * 2; // Calculate the y position for the tail segment, increasing wiggle size
        
//         ctx.lineTo(tailX, tailY); // Draw a line to the calculated tail segment position
//     }
    
//     // Set the stroke style for the tail
//     ctx.strokeStyle = sperm.color; // Set the stroke color to the sperm's color
//     ctx.lineWidth = headSize * 0.7; // Set the line width based on the head size
//     ctx.lineCap = 'round'; // Set the line cap style to round for smoother edges
//     ctx.stroke(); // Render the tail by stroking the path
// }

    // Function to draw the egg cell
    // function drawEgg() {
    //   const vibrationAmount = Math.sin(egg.vibration) * 2;
      
    //   // Create outer glow
    //   const glowGradient = ctx.createRadialGradient(
    //     egg.x, egg.y + vibrationAmount, egg.radius * 0.5,
    //     egg.x, egg.y + vibrationAmount, egg.radius * 2
    //   );
    //   glowGradient.addColorStop(0, 'rgba(245, 158, 11, 0.3)');
    //   glowGradient.addColorStop(1, 'rgba(245, 158, 11, 0)');
      
    //   ctx.fillStyle = glowGradient;
    //   ctx.beginPath();
    //   ctx.arc(egg.x, egg.y + vibrationAmount, egg.radius * 2, 0, Math.PI * 2);
    //   ctx.fill();

    //   // Create main egg gradient
    //   const eggGradient = ctx.createRadialGradient(
    //     egg.x, egg.y + vibrationAmount, 0,
    //     egg.x, egg.y + vibrationAmount, egg.radius
    //   );
    //   eggGradient.addColorStop(0, '#fef3c7');
    //   eggGradient.addColorStop(0.7, '#fcd34d');
    //   eggGradient.addColorStop(1, '#f59e0b');
      
    //   // Draw the egg with the gradient
    //   ctx.fillStyle = eggGradient;
    //   ctx.beginPath();
    //   ctx.arc(egg.x, egg.y + vibrationAmount, egg.radius, 0, Math.PI * 2);
    //   ctx.fill();
      
    //   // Draw egg border
    //   ctx.strokeStyle = '#d97706';
    //   ctx.lineWidth = 3;
    //   ctx.beginPath();
    //   ctx.arc(egg.x, egg.y + vibrationAmount, egg.radius, 0, Math.PI * 2);
    //   ctx.stroke();

    //   // Draw the inner cell features
    //   ctx.fillStyle = 'rgba(255, 251, 235, 0.8)';
    //   ctx.beginPath();
    //   ctx.arc(egg.x, egg.y + vibrationAmount, egg.radius * 0.5, 0, Math.PI * 2);
    //   ctx.fill();
      
    //   ctx.fillStyle = '#fbbf24';
    //   ctx.beginPath();
    //   ctx.arc(egg.x, egg.y + vibrationAmount, egg.radius * 0.25, 0, Math.PI * 2);
    //   ctx.fill();

    //   egg.vibration += 0.05; // Increase vibration for animation
    // }
function drawEgg() {
    // Calculate the amount of vibration based on a sine function for smooth oscillation
    const vibrationAmount = Math.sin(egg.vibration) * 2;
    
    // Create an outer glow effect for the egg
    const glowGradient = ctx.createRadialGradient(
        egg.x, egg.y + vibrationAmount, egg.radius * 0.5, // Inner circle (center and radius)
        egg.x, egg.y + vibrationAmount, egg.radius * 2    // Outer circle (center and radius)
    );
    // Define color stops for the glow gradient
    glowGradient.addColorStop(0, 'rgba(245, 158, 11, 0.1)'); // Semi-transparent color at the center
    glowGradient.addColorStop(1, 'rgba(245, 158, 11, 0.5)');  // Opaque color at the outer edge
    
    // Set the fill style to the glow gradient and draw the outer glow
    ctx.fillStyle = glowGradient;
    ctx.beginPath();
    ctx.arc(egg.x, egg.y + vibrationAmount, egg.radius * 2, 0, Math.PI * 2); // Draw a circle
    ctx.fill(); // Fill the circle with the glow gradient

    // Create the main gradient for the egg itself
    const eggGradient = ctx.createRadialGradient(
        egg.x, egg.y + vibrationAmount, 0, // Inner circle (center and radius)
        egg.x, egg.y + vibrationAmount, egg.radius // Outer circle (center and radius)
    );
    // Define color stops for the egg gradient
    eggGradient.addColorStop(0, '#fef3c7'); // Light color at the center
    eggGradient.addColorStop(0.7, '#fcd34d'); // Medium color
    eggGradient.addColorStop(1, '#f59e0b'); // Darker color at the edge
    
    // Set the fill style to the egg gradient and draw the egg
    ctx.fillStyle = eggGradient;
    ctx.beginPath();
    ctx.arc(egg.x, egg.y + vibrationAmount, egg.radius, 0, Math.PI * 2); // Draw a circle
    ctx.fill(); // Fill the circle with the egg gradient
    
    // Draw the border of the egg
    ctx.strokeStyle = 'rgba(217,119,6,0.7)'; // Set the stroke color
    ctx.lineWidth = 3; // Set the line width for the border
    ctx.beginPath();
    ctx.arc(egg.x, egg.y + vibrationAmount, egg.radius, 0, Math.PI * 2); // Draw a circle for the border
    ctx.stroke(); // Apply the stroke to the circle

    // Draw inner cell features of the egg
    ctx.fillStyle = 'rgba(255, 251, 235, 0.8)'; // Set fill color for the inner cell
    ctx.beginPath();
    ctx.arc(egg.x, egg.y + vibrationAmount, egg.radius * 0.5, 0, Math.PI * 2); // Draw a smaller circle
    ctx.fill(); // Fill the smaller circle

    ctx.fillStyle = 'rgba(251,191,36,0.6)'; // Set a different fill color for another inner feature
    ctx.beginPath();
    ctx.arc(egg.x, egg.y + vibrationAmount, egg.radius * 0.25, 0, Math.PI * 2); // Draw an even smaller circle
    ctx.fill(); // Fill the smallest circle

    // Update the vibration value to animate the egg's movement
    egg.vibration += 0.05; // Increment the vibration for the next frame
}



    // Function to update sperm positions
// Function to update sperm positions
function updateSperm() {
    spermArray.forEach((sperm, index) => {
        // Calculate the direction toward the egg
        const dx = egg.x - sperm.x;
        const dy = egg.y - sperm.y;
        const distance = Math.sqrt(dx * dx + dy * dy);
        
        // Attraction factor increases as sperm gets closer to egg
        const attractionFactor = 1 + (egg.radius * 4 / Math.max(distance, 1));

        // Normalize the direction and move the sperm toward the egg
        if (distance > 0) {
            sperm.x += (dx / distance) * sperm.speed * attractionFactor * 0.05;
            sperm.y += (dy / distance) * sperm.speed * attractionFactor * 0.05;
        }

        // Check if the sperm has reached the egg
        if (distance < egg.radius) {
            // Create a new sperm starting from left side
            spermArray[index] = createSperm(); 
        }

        // Add some random movement for more natural behavior
        sperm.y += (Math.sin(Date.now() * 0.001 + index) * 0.3);
    });
}    
    // function updateSperm() {
    //   spermArray.forEach((sperm, index) => {
    //     // Calculate the direction toward the egg
    //     const dx = egg.x - sperm.x;
    //     const dy = egg.y - sperm.y;
    //     const distance = Math.sqrt(dx * dx + dy * dy);
        
    //     // Attraction factor increases as sperm gets closer to egg
    //     const attractionFactor = 1 + (egg.radius * 4 / Math.max(distance, 1));

    //     // Normalize the direction and move the sperm toward the egg
    //     if (distance > 0) {
    //       sperm.x += (dx / distance) * sperm.speed * attractionFactor * 0.05;
    //       sperm.y += (dy / distance) * sperm.speed * attractionFactor * 0.05;
    //     }

    //     // Check if the sperm has reached the egg
    //     if (distance < egg.radius) {
    //       // Create a new sperm starting from left side
    //       spermArray[index] = createSperm(); 
    //     }

    //     // Add some random movement for more natural behavior
    //     sperm.y += (Math.sin(Date.now() * 0.001 + index) * 0.3);
    //   });
    // }

    // Animation loop
    let animationFrameId;
    const draw = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      drawEgg();
      spermArray.forEach(drawSperm);
      updateSperm();
      animationFrameId = requestAnimationFrame(draw);
    };

    draw();

    // Clean up
    return () => {
      window.removeEventListener('resize', resizeCanvas);
      cancelAnimationFrame(animationFrameId);
    };
  }, []);

  return (
    <canvas 
      ref={canvasRef} 
      className="absolute inset-0 w-full h-full pointer-events-none" 
      style={{ zIndex: 5 }}
    />
  );
};

export default FertilizationCanvas;